import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Camera, Loader2, Sparkles } from "lucide-react";
import { compressImage } from "@/lib/image";

export const IdentificaCodice = ({ code, onApply }) => {
  const [state, setState] = useState({ loading: true, data: null, error: false });
  const fileRef = useRef(null);

  const apply = (data) => { setState({ loading: false, data, error: false }); onApply?.(data); };

  useEffect(() => {
    if (!code) return;
    setState({ loading: true, data: null, error: false });
    api.get(`/magazzino/identify-code/${encodeURIComponent(code)}`)
      .then(({ data }) => apply(data))
      .catch(() => { setState({ loading: false, data: null, error: true }); onApply?.(null); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  const onPhoto = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setState((s) => ({ ...s, loading: true }));
    try {
      const blob = await compressImage(f, { maxDim: 1600, quality: 0.8 }).catch(() => f);
      const fd = new FormData();
      fd.append("file", blob, f.name || "etichetta.jpg");
      fd.append("code", code);
      const { data } = await api.post("/magazzino/identify-photo", fd, { headers: { "Content-Type": "multipart/form-data" } });
      apply(data);
    } catch {
      setState({ loading: false, data: null, error: true });
    }
  };

  const d = state.data;
  return (
    <div className="rounded-md border border-primary/30 bg-primary/5 p-3 text-sm space-y-2" data-testid="identifica-codice">
      {state.loading && <div className="flex items-center gap-2 text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /> Riconoscimento prodotto in corso…</div>}
      {!state.loading && d?.riconosciuto && (
        <div data-testid="identifica-ok">
          <div className="flex items-center gap-2 font-semibold"><Sparkles className="h-4 w-4 text-primary" /> {d.suggerimento.nome}</div>
          <div className="text-xs text-muted-foreground">
            {d.suggerimento.categoria || "—"} · {d.suggerimento.unita_misura} · fonte: {d.fonte}
            {d.match && <> · corrisponde a <strong>{d.match.nome}</strong> ({Math.round(d.match.confidenza * 100)}%)</>}
          </div>
        </div>
      )}
      {!state.loading && !d?.riconosciuto && (
        <div className="text-xs text-muted-foreground" data-testid="identifica-ko">
          {state.error ? "Riconoscimento non riuscito." : "Codice non trovato nelle banche dati online."} Scatta una foto dell'etichetta e lo riconosco io.
        </div>
      )}
      {!state.loading && (
        <>
          <input ref={fileRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={onPhoto} data-testid="identifica-foto-input" />
          <Button type="button" size="sm" variant={d?.riconosciuto ? "ghost" : "default"} className="h-9" onClick={() => fileRef.current?.click()} data-testid="identifica-foto-btn">
            <Camera className="h-4 w-4 mr-2" /> {d?.riconosciuto ? "Non è giusto? Foto dell'etichetta" : "Scatta foto dell'etichetta"}
          </Button>
        </>
      )}
    </div>
  );
};
